(() => {
  const desktop = window.matchMedia('(min-width: 1201px)');
  const menus = Array.from(document.querySelectorAll('.p01__navlinks > .p01__mega'));
  if (!menus.length) return;

  let closeTimer = 0;

  const hydrateImages = (root) => {
    root?.querySelectorAll('img[data-deferred-image]').forEach((image) => {
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      if (image.dataset.sizes) image.sizes = image.dataset.sizes;
      if (image.dataset.src) image.src = image.dataset.src;
      delete image.dataset.srcset;
      delete image.dataset.sizes;
      delete image.dataset.src;
      image.removeAttribute('data-deferred-image');
    });
  };

  const close = (menu) => {
    menu.classList.remove('is-open');
    menu.querySelector(':scope > .p01__mega-trigger')?.setAttribute('aria-expanded', 'false');
  };

  const closeAll = (except) => {
    menus.forEach((menu) => {
      if (menu !== except) close(menu);
    });
  };

  const open = (menu) => {
    if (!desktop.matches) return;
    window.clearTimeout(closeTimer);
    closeAll(menu);
    const activeCategory = menu.querySelector('.p01__mega-category.is-active');
    hydrateImages(activeCategory || menu.querySelector(':scope > .p01__mega-panel'));
    menu.classList.add('is-open');
    menu.querySelector(':scope > .p01__mega-trigger')?.setAttribute('aria-expanded', 'true');
  };

  const scheduleClose = (menu) => {
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => close(menu), 260);
  };

  menus.forEach((menu) => {
    const trigger = menu.querySelector(':scope > .p01__mega-trigger');
    const panel = menu.querySelector(':scope > .p01__mega-panel');
    if (!trigger || !panel) return;

    const categories = Array.from(panel.querySelectorAll('.p01__mega-category'));
    if (categories.length) {
      const activateCategory = (category, hydrate = true) => {
        categories.forEach((item) => item.classList.toggle('is-active', item === category));
        if (hydrate) hydrateImages(category);
      };
      activateCategory(categories.find((item) => item.classList.contains('is-default')) || categories[0], false);
      categories.forEach((category) => {
        category.addEventListener('pointerenter', () => activateCategory(category));
        category.addEventListener('focusin', () => activateCategory(category));
      });
    }

    trigger.addEventListener('pointerenter', () => open(menu));
    trigger.addEventListener('pointerleave', () => scheduleClose(menu));
    panel.addEventListener('pointerenter', () => {
      window.clearTimeout(closeTimer);
      open(menu);
    });
    panel.addEventListener('pointerleave', () => scheduleClose(menu));
    panel.addEventListener('click', (event) => {
      if (event.target.closest('a[href]')) closeAll();
    });
    trigger.addEventListener('focus', () => open(menu));
    menu.addEventListener('focusout', (event) => {
      if (!menu.contains(event.relatedTarget)) scheduleClose(menu);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      window.clearTimeout(closeTimer);
      closeAll();
    }
  });

  desktop.addEventListener('change', () => {
    window.clearTimeout(closeTimer);
    closeAll();
  });
})();
